//简体中文
export default {
  Login: {
    Title: "登录您的账户",
    describe: "请登录或创建一个账户以开始使用。",
    Google: " 继续使用 Google",
    Apple: " 继续使用 Apple",
    or: "或者",
    Emailplaceholder: "电子邮件地址",
    Passwordplaceholder: "密码",
    Login: "登录",
    forgot: "忘记密码？",
    notAccount: "还没有 Fineshare 账户？",
    Signup: "注册",
    InvalidEmail: "无效的邮箱格式。",
    InvalidPassword: "密码必须至少为 6 个字符。",
    loading: "加载中..",
    login: "登录",
    errorText: "登录失败，请检查您的用户名和密码",
  },
  signup: {
    Title: "创建您的账户",
    describe: "几秒钟内创建您的 Fineshare 账户。",
    Google: "使用 Google 注册",
    Apple: "使用 Apple 注册",
    or: "或者",
    Emailplaceholder: "请输入邮箱地址",
    Passwordplaceholder: "请输入6位密码",
    Already: "已经有账户了？",
    Login: "登录",
    By: "通过创建账户，我同意我已阅读并接受",
    Privacy: "隐私政策",
    Terms: "使用条款。",
    and: "和",
    signupText: "创建您的账户",
    InvalidEmail: "无效的邮箱格式。",
    InvalidPassword: "密码必须至少为 6 个字符。",
    loading: "加载中..",
    passwordError: "该邮箱地址已被注册",
    again: "您请求过于频繁，请稍后再试",
    Registration: "注册失败，请检查您的邮箱和密码。",
    hasRegistered: "该邮箱地址已被注册",
    Title2: "创建您的 Fineshare 账户",
  },
  Home: {
    Welcome: "欢迎来到 Fineshare 账户中心",
    Hi: "你好，",
    Order: "我的订单",
    orders: "查看我们的采购订单",
    Learn: "了解更多",
    Product: "管理产品",
    products: "查看我购买的产品",
    Setting: "账户设置",
    Settings: "账户详情并修改密码",
    account: "充分利用您的账户",
    FineCam: "FineCam",
    FineCams: "随时随地创建和分享您的灵感视频",
    FineVoice: "FineVoice",
    FineVoices: "用您最喜欢的声音创建配音，按您的方式",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "转变您的声音，传递您的情感",
    Singify: "Singify",
    Singifys: "用您想要的声音创建 AI 翻唱",
  },
  success: {
    Congratulations: "恭喜！",
    successfully: "您的 Fineshare 账户已成功创建。",
  },
  successapp: {
    Successful: "登录成功！",
    successfully1: "您已成功登录到 Fineshare 账户，现在可以开始使用应用程序。",
    successfully2:
      "您已成功登录到 Fineshare 账户。您现在可以关闭此窗口并开始使用应用程序。",
    Go: "前往 Fineshare 用户中心",
  },
  forgot: {
    ForgotPas: "忘记密码？",
    Enter1: "请输入重置密码的邮箱",
    Enter2: "请输入您的电子邮件地址，我们将发送重置密码的链接。",
    exmple: "{email}",
    Back: "返回登录",
    submitText: "提交",
    errorText: "请输入您的电子邮件地址",
    loading: "加载中...",
    sent: "我们已向您的电子邮件地址发送了一封邮件",
    notExist: "您的电子邮件不存在，请确认您的邮箱",
    Reset: "重置失败，请确认您的电子邮件",
  },
  account: {
    Settings: "账户设置",
    Change: "修改您的账户信息、密码等。",
    Personal: "个人信息",
    email: "电子邮件：",
    Name: "用户名：",
    Edit: "编辑",
    title: "修改用户名",
    message: "输入的名称不能为空。",
    placeholder: "请输入用户名",
    Reset: "重置密码",
    Resets: "您可以重置密码，请输入6位或更多数字和密码",
    ResetPas: "重置密码",
    Delete: "删除账户",
    Deletes: "此操作将永久删除您的账户及其所有数据，您将无法重新激活该账户。",
    sure: "您确定要删除您的 Fineshare 账户吗？",
    sures:
      "一旦您的账户被删除，所有 Fineshare 上的数据将被永久删除。为了继续删除账户，我们已向您发送了验证码。请输入验证码并点击确认。",
    Deletebtn: "删除",
    Deleteplaceholder: "请输入6位验证码",
  },
  order: {
    Order: "我的订单",
    history: "您的订单历史已记录在此页面",
    dont: "您还没有产品",
    Buy: "立即购买以获得更多优化，点击下面的按钮立即购买",
    BuyBtn: "立即购买",
    OrderId: "订单编号：",
    Price: "价格：",
    Date: "订单日期：",
  },
  Product: {
    Product: "我的产品",
    products: "您登录账户中的产品",
    dont: "您还没有产品",
    Management: "管理设备 >",
  },
  redeem: {
    Redeem: "兑换会员",
    products: "在这里您可以兑换 Fineshare 产品",
    Please: "请输入您的兑换码",
    placeholder: "兑换码",
    Submit: "提交",
    Notes: "备注：",
    Notes1: "1.兑换码格式：XXXXX；",
    Notes2: "2.要查看您的兑换产品，请点击“产品”菜单。",
    Successfully: "兑换成功",
    Follow: "按照以下步骤开始使用 VoiceTrans：",
    step1: "1. 下载并安装 Fineshare VoiceTrans。",
    step2: "2. 打开 VoiceTrans 并进入 ",
    Account: "帐户",
    step3: "3. 输入您的电子邮件和密码登录您的 Fineshare 账户。",
    Tips: "提示：为了更好的使用，请阅读 ",
    guide: "指南",
    Redemption: "兑换失败",
    redeemed: "该兑换码已被使用，请打开软件并重新登录您的账户开始使用。",
    Failed: "兑换失败",
    check: "请检查您的兑换码。",
  },
  details: {
    Product: "我的产品",
    products: "您购买的所有产品都在此页面",
    Back: "返回列表",
    Name: "设备名称",
    system: "设备系统",
    status: "设备状态",
    Operation: "操作",
    Delete: "删除",
    contact: "当前不支持直接移除设备，如需移除设备，请通过以下方式联系我们：",
  },
  nav: {
    Home: "首页",
    Account: "账户",
    Order: "订单",
    Product: "产品",
    Redeem: "兑换",
    Help: "帮助中心",
  },
  auth: {
    Authorization: "授权成功！",
    wait: "正在返回应用程序，请稍候...",
  },
  notfound: {
    Not: "页面未找到",
    Unfortunately: "很抱歉，您所寻找的页面不存在，或者您输入的链接有误。",
    Home: "返回首页",
  },
  topuser: {
    Settings: "账户设置",
    language: "语言",
    Logout: "注销",
  },
  loginweb: {
    Conversion: "转换即将开始",
    currently: "当前排队人数为 ",
    people: "人！",
    Please: "请登录，我们将在转换完成后将结果发送到您的电子邮件。",
    dont: "我不想登录",
  },
  mobilelogin: {
    Welcome: "欢迎使用 Fineshare！请登录以开始使用。",
  },
  reset: {
    Reset: "重置新密码",
    Password: "密码要求至少6个字符，并包含至少1个字母和1个数字。",
    password: "请输入您的新密码",
    Back: "返回登录",
    Congratulations: "恭喜！",
    successfully: "密码重置成功，立即开始登录",
    Login: "登录",
    Please: "请输入6个数字和字母",
    failed: "密码重置失败，请点击邮件中的重置链接",
  },
  verification: {
    verification: "请输入验证码",
    haveverification: "我们已发送验证码到 ",
    Please: "。请在下方输入您收到的验证码：",
    Enter: "请输入6位验证码",
    Resend: "重新发送验证码",
    Wait: "等待 ",
    again: " 秒后重新发送",
    Verify: "验证",
    error: "验证码错误",
    verificationcode: "请输入验证码",
  },
};
